'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('../../../actions');

var _actions2 = _interopRequireDefault(_actions);

var _AnimatedInput = require('../AnimatedInput');

var _AnimatedInput2 = _interopRequireDefault(_AnimatedInput);

var _noHtml = require('../../../../validation/noHtml');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common', 'Validation');

function mapStateToProps(state) {
    return {
        loading: state.cart.settingCoupon || false
    };
}

var mapDispatchToProps = {
    setCoupon: _actions2.default.setCoupon
};

var DiscountCouponForm = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(DiscountCouponForm, _React$PureComponent);

    function DiscountCouponForm() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DiscountCouponForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DiscountCouponForm.__proto__ || (0, _getPrototypeOf2.default)(DiscountCouponForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            code: ''
        }, _this.codeChanged = function (e) {
            var code = e.target.value;
            _this.setState(function (previousState) {
                return { code: code, error: (0, _noHtml.containsHtmlTag)(code) ? previousState.error : null };
            });
        }, _this.useCoupon = function () {
            if ((0, _noHtml.containsHtmlTag)(_this.state.code)) {
                _this.setState({ error: Resx.Validation.NoHtml_ValidationError });
                return;
            }
            if (_this.state.code) {
                _this.props.setCoupon(_this.state.code);
                _this.setState({ code: '', error: null });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DiscountCouponForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var btnClass = 'btn btn--grey';
            if (this.props.loading) {
                btnClass += ' btn--pending';
            }
            return _react2.default.createElement(
                'div',
                { className: 'cart__coupon-add' },
                _react2.default.createElement(
                    'label',
                    { className: 'h3 width--30' },
                    Resx.App.DiscountCode,
                    ' / ',
                    Resx.App.GiftVoucher.toLowerCase()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form__group form__input width--70' },
                    _react2.default.createElement(_AnimatedInput2.default, { id: 'coupon', value: this.state.code,
                        onChange: this.codeChanged,
                        onBlur: this.useCoupon,
                        onKeyPress: function onKeyPress(e) {
                            e.key === 'Enter' && _this2.useCoupon();
                        }
                    }),
                    this.state.error && _react2.default.createElement(
                        'span',
                        { className: 'field-validation-error' },
                        this.state.error
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'coupon' },
                        Resx.Common.Insert,
                        '\xA0',
                        Resx.App.DiscountCode.toLowerCase()
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: btnClass, onClick: this.useCoupon },
                        Resx.Common.Use
                    )
                )
            );
        }
    }]);
    return DiscountCouponForm;
}(_react2.default.PureComponent), _class2.propTypes = {
    setCoupon: _propTypes2.default.func,
    loading: _propTypes2.default.bool
}, _temp2)) || _class);
exports.default = DiscountCouponForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/DiscountCouponForm.js
// module id = 1018
// module chunks = 0